import React from 'react';
import { motion } from 'framer-motion';
import { MapPinIcon, PhoneIcon, ClockIcon } from 'lucide-react';
export function Location() {
  return <section id="location" className="py-32 px-6 bg-matte-black" data-id="element-132">
      <div className="max-w-7xl mx-auto" data-id="element-133">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-20" data-id="element-134">
          <h2 className="font-playfair text-5xl md:text-6xl font-bold text-off-white mb-4" data-id="element-135">
            Visit Us
          </h2>
          <p className="font-inter text-lg text-off-white/60" data-id="element-136">
            Located in the heart of the city
          </p>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-137">
          {/* Map placeholder */}
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="relative aspect-square lg:aspect-auto rounded-2xl overflow-hidden" data-id="element-138">
            <motion.div initial={{
            scale: 1.2
          }} whileInView={{
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 1.2,
            ease: 'easeOut'
          }} className="w-full h-full bg-gradient-to-br from-deep-green/30 via-matte-black to-deep-green/20 flex items-center justify-center border border-off-white/10" data-id="element-139">
              <MapPinIcon className="text-soft-gold" size={80} strokeWidth={1} data-id="element-140" />
            </motion.div>
          </motion.div>

          {/* Contact info */}
          <motion.div initial={{
          opacity: 0,
          x: 50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="flex flex-col justify-center space-y-8" data-id="element-141">
            <div className="flex items-start gap-4" data-id="element-142">
              <div className="w-12 h-12 rounded-full bg-soft-gold/10 flex items-center justify-center flex-shrink-0" data-id="element-143">
                <MapPinIcon className="text-soft-gold" size={24} data-id="element-144" />
              </div>
              <div data-id="element-145">
                <h3 className="font-inter font-semibold text-off-white text-xl mb-2" data-id="element-146">
                  Address
                </h3>
                <p className="font-inter text-off-white/70 leading-relaxed" data-id="element-147">
                  123 Savile Row
                  <br data-id="element-148" />
                  Mayfair, London
                  <br data-id="element-149" />
                  W1S 3PJ
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4" data-id="element-150">
              <div className="w-12 h-12 rounded-full bg-soft-gold/10 flex items-center justify-center flex-shrink-0" data-id="element-151">
                <PhoneIcon className="text-soft-gold" size={24} data-id="element-152" />
              </div>
              <div data-id="element-153">
                <h3 className="font-inter font-semibold text-off-white text-xl mb-2" data-id="element-154">
                  Phone
                </h3>
                <p className="font-inter text-off-white/70" data-id="element-155">+44 20 7123 4567</p>
              </div>
            </div>

            <div className="flex items-start gap-4" data-id="element-156">
              <div className="w-12 h-12 rounded-full bg-soft-gold/10 flex items-center justify-center flex-shrink-0" data-id="element-157">
                <ClockIcon className="text-soft-gold" size={24} data-id="element-158" />
              </div>
              <div data-id="element-159">
                <h3 className="font-inter font-semibold text-off-white text-xl mb-2" data-id="element-160">
                  Opening Hours
                </h3>
                <div className="font-inter text-off-white/70 space-y-1" data-id="element-161">
                  <p data-id="element-162">Monday - Friday: 9:00 AM - 8:00 PM</p>
                  <p data-id="element-163">Saturday: 10:00 AM - 6:00 PM</p>
                  <p data-id="element-164">Sunday: Closed</p>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}